/* Analytics sends only page/form context. File names/sizes are used locally for validation only. */
(function () {
  'use strict';
  var pendingKey = 'tempo.photo.enquiry.pending.v1';
  var serviceKey = 'tempo.enquiry.service.v1';
  var observed = new WeakSet();
  var hour = 3600000;
  function allowed() { return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed()); }
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } }
  function write(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } }
  function remove(key) { try { sessionStorage.removeItem(key); } catch (_) {} }
  function fresh(value) { return value && Date.now() - value.time >= 0 && Date.now() - value.time < hour; }
  function path(value) { return /^\/[a-zA-Z0-9_\-/]*$/.test(value || '') ? value : ''; }
  function service(wrapper) {
    var handle = wrapper.getAttribute('data-service-handle') || '';
    var page = path(wrapper.getAttribute('data-page-path'));
    if (/^[a-z0-9-]+$/.test(handle) && handle !== 'contact-us') return { handle: handle, page: page, time: Date.now() };
    var last = read(serviceKey);
    return fresh(last) ? last : { handle: 'direct-enquiry', page: '(direct enquiry)' };
  }
  function attach() {
    document.querySelectorAll('[data-tempo-photo-enquiry]').forEach(function (wrapper) {
      if (allowed()) {
        var current = service(wrapper);
        if (wrapper.getAttribute('data-service-handle')) write(serviceKey, current);
      }
      var embed = wrapper.querySelector('shopify-forms-embed');
      var root = embed && embed.shadowRoot;
      if (!root || observed.has(root)) return;
      observed.add(root);
      wrapper.setAttribute('data-tracking-status', 'ready');
      var attempt = null;
      root.addEventListener('submit', function (event) {
        var uploadError = '';
        root.querySelectorAll('input[type="file"]').forEach(function (input) {
          Array.from(input.files || []).forEach(function (file) {
            if (file.size > 20 * 1024 * 1024) uploadError = 'Each photo must be 20 MB or smaller. Please choose a smaller file.';
            else if (!/\.(png|jpe?g|webp|svg|heic|gif|pdf)$/i.test(file.name)) uploadError = 'Please choose a PNG, JPEG, WebP, SVG, HEIC, GIF or PDF file.';
          });
        });
        var errorNode = root.querySelector('[data-tempo-upload-error]');
        if (uploadError) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!errorNode) {
            errorNode = document.createElement('p');
            errorNode.setAttribute('data-tempo-upload-error', '');
            errorNode.setAttribute('role', 'alert');
            root.querySelector('form').prepend(errorNode);
          }
          errorNode.textContent = uploadError;
          wrapper.setAttribute('data-tracking-status', 'upload-validation-error');
          return;
        }
        if (errorNode) errorNode.remove();
        if (!allowed()) return;
        var attribution = service(wrapper);
        attempt = {
          time: Date.now(), form_id: 'shopify_forms_1213464',
          service_handle: attribution.handle, service_page: attribution.page,
          enquiry_page: path(wrapper.getAttribute('data-page-path')),
          is_test: new URLSearchParams(window.location.search).get('tempo_tracking_test') === '1' ? 'true' : 'false'
        };
        write(pendingKey, attempt);
        wrapper.setAttribute('data-tracking-status', 'awaiting-success');
      }, true);
      function success() {
        if (!attempt || !allowed() || !fresh(attempt) || typeof window.gtag !== 'function') return;
        var heading = Array.from(root.querySelectorAll('h1,h2,h3')).some(function (node) { return node.textContent.trim() === 'Thank you for your enquiry'; });
        if (!heading || root.querySelector('form')) return;
        var params = {
          send_to: 'G-S2XL2TVV0W', form_id: attempt.form_id,
          service_handle: attempt.service_handle, service_page: attempt.service_page,
          enquiry_page: attempt.enquiry_page, is_test: attempt.is_test, transport_type: 'beacon'
        };
        if (attempt.is_test === 'true') params.debug_mode = true;
        attempt = null;
        remove(pendingKey);
        window.gtag('event', 'generate_lead', params);
        wrapper.setAttribute('data-tracking-status', 'event-dispatched');
        wrapper.setAttribute('data-tracked-service-page', params.service_page);
        wrapper.setAttribute('data-tracked-test', params.is_test);
      }
      new MutationObserver(success).observe(root, { childList: true, subtree: true });
      window.setInterval(success, 1000);
    });
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) { remove(pendingKey); remove(serviceKey); }
    attach();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach); else attach();
  var attempts = 0;
  var timer = window.setInterval(function () { attach(); if (++attempts >= 60) window.clearInterval(timer); }, 500);
}());

